var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.66568C10 10.1757 9.58667 10.589 9.07667 10.589C8.56733 10.589 8.15333 10.1757 8.15333 9.66568V7.51235C8.15333 7.00235 8.56733 6.58901 9.07667 6.58901C9.58667 6.58901 10 7.00235 10 7.51235V9.66568ZM6.92333 9.66568C6.92333 10.1757 6.51 10.589 6 10.589C5.49 10.589 5.07667 10.1757 5.07667 9.66568V7.51235C5.07667 7.00235 5.49 6.58901 6 6.58901C6.51 6.58901 6.92333 7.00235 6.92333 7.51235V9.66568ZM3.84667 9.66568C3.84667 10.1757 3.43267 10.589 2.92333 10.589C2.41333 10.589 2 10.1757 2 9.66568V7.51235C2 7.00235 2.41333 6.58901 2.92333 6.58901C3.43267 6.58901 3.84667 7.00235 3.84667 7.51235V9.66568ZM6 3.25568V1.16768C6 0.635678 5.406 0.317678 4.96333 0.613012L0.594 2.85968C0.222667 3.10701 0 3.52368 0 3.96901V11.2557C0 11.9917 0.597333 12.589 1.33333 12.589H10.6667C11.4027 12.589 12 11.9917 12 11.2557V1.16768C12 0.635678 11.406 0.317678 10.9633 0.613012L6 3.25568Z",
    fill: "white",
    fillOpacity: 0.74
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallVector);
export default __webpack_public_path__ + "static/media/smallVector.6bb68a40.svg";
export { ForwardRef as ReactComponent };